import "./ClipPaths.css";

function ClipPaths() {
  return (
    <div className="clip-paths">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="87"
        fill="none"
      >
        <clipPath id="specialists">
          <rect
            width="62"
            height="88"
            x="21.918"
            y="-7.949"
            fill="#BBA1FF"
            rx="31"
            transform="rotate(20 21.918 -7.95)"
          />
        </clipPath>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="226"
        height="775"
        fill="none"
      >
        <clipPath id="authors_big">
          <rect
            width="196.472"
            height="278.863"
            x="68.375"
            y="-27"
            fill="#BBA1FF"
            rx="98.236"
            transform="rotate(20 68.375 -27)"
          />
        </clipPath>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="172"
        height="210"
        fill="none"
      >
        <clipPath id="authors_middle">
          <rect
            width="150.161"
            height="213.131"
            x="51.895"
            y="-21"
            fill="#BBA1FF"
            rx="75.08"
            transform="rotate(20 51.895 -21)"
          />
        </clipPath>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="115"
        height="139"
        fill="none"
      >
        <clipPath id="authors_small">
          <rect
            width="98.938"
            height="140.428"
            x="35.027"
            y="-13"
            fill="#BBA1FF"
            rx="49.469"
            transform="rotate(20 35.027 -13)"
          />
        </clipPath>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1 1"
        preserveAspectRatio="xMidYMid meet"
      >
        <clipPath id="starlike-svg" clipPathUnits="objectBoundingBox">
          <path d="M0.965,0.569 l-0.017,0.014 a0.137,0.104,0,0,0,-0.027,0.105 l0.007,0.014 a0.138,0.104,0,0,1,-0.075,0.131 l-0.027,0.009 a0.138,0.104,0,0,0,-0.08,0.074 h0 a0.138,0.104,0,0,1,-0.183,0.076 l-0.014,-0.004 a0.136,0.103,0,0,0,-0.097,0 l-0.014,0.004 a0.138,0.104,0,0,1,-0.183,-0.076 h0 a0.138,0.104,0,0,0,-0.08,-0.074 l-0.027,-0.009 a0.138,0.104,0,0,1,-0.075,-0.131 l0.007,-0.014 a0.137,0.104,0,0,0,-0.027,-0.105 l-0.017,-0.014 a0.138,0.104,0,0,1,0,-0.139 l0.017,-0.014 a0.137,0.104,0,0,0,0.027,-0.105 l-0.007,-0.014 a0.138,0.104,0,0,1,0.075,-0.131 l0.027,-0.009 a0.138,0.104,0,0,0,0.08,-0.074 h0 a0.138,0.104,0,0,1,0.183,-0.076 l0.014,0.004 a0.136,0.103,0,0,0,0.097,0 l0.014,-0.004 a0.138,0.104,0,0,1,0.183,0.076 h0 a0.138,0.104,0,0,0,0.08,0.074 l0.027,0.009 a0.138,0.104,0,0,1,0.075,0.131 l-0.007,0.014 a0.138,0.104,0,0,0,0.027,0.105 l0.017,0.014 A0.138,0.104,0,0,1,0.965,0.569"></path>
        </clipPath>
      </svg>
      <svg viewBox="0 0 1 1">
        <clipPath id="concave-rectangle" clipPathUnits="objectBoundingBox">
          <path d="m0.78,0.995 l-0.151,-0.031 a0.506,0.386,0,0,0,-0.262,0 l-0.147,0.03 c-0.128,0.026,-0.247,-0.06,-0.214,-0.156 l0.08,-0.239 a0.526,0.401,0,0,0,0,-0.199 l-0.079,-0.235 c-0.033,-0.097,0.088,-0.183,0.217,-0.156 l0.126,0.027 a0.511,0.389,0,0,0,0.272,0.001 l0.157,-0.032 c0.128,-0.026,0.246,0.058,0.216,0.154 l-0.078,0.246 a0.521,0.397,0,0,0,0,0.188 l0.079,0.248 c0.03,0.095,-0.088,0.18,-0.216,0.154"></path>
        </clipPath>
      </svg>
    </div>
  );
}

export default ClipPaths;
